export const DELETE_QUESTION = "DELETE_QUESTION";
export const UPDATE_QUESTION = "UPDATE_QUESTION";
export const CREATE_QUESTION = "CREATE_QUESTION";
export const DELETE_PLAY = "DELETE_PLAY";
export const SET_PLAYS = "SET_PLAYS";
